import React from 'react'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
import ReportTable from './components/ReportTable'

const crmBreadcrumb: PageLink = {title: 'CRM', path: '/', isSeparator: false, isActive: false}

function ReportPage() {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb]}>Report</PageTitle>
              <ReportTable />
            </>
          }
        />
      </Route>
      <Route path='*' element={<Navigate to='/error/404' />} />
    </Routes>
  )
}

export default ReportPage
